module.exports = __webpack_public_path__ + "static/media/156952229779483141443.b88110ec.jpg";